import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaMinus(complexDenominator, c1, r1, r5, rx, sImaginary) {
  var result = Complex.createComplex(0, (sImaginary * r5 * c1 * rx) / r1).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexRParallel, r1) {
  var complexR1 = Complex.createComplex(r1, 0);
  var result = complexRParallel.divide(complexR1);
  return result;
}
